// @ts-nocheck 7dd6ff4d
import actionTypes from './stateBoxActionTypes';

const setIsRepeaterStateAllowed = (isRepeaterStateAllowed) => ({
  type: actionTypes.SET_IS_REPEATER_STATE_ALLOWED,
  isRepeaterStateAllowed,
});
export { setIsRepeaterStateAllowed };
